import { useState } from 'react'
import { useToggle } from 'usehooks-ts'

import { AdminSliderPanel } from '@/components/AdminSliderPanel'
import { AdminButton } from '@/components/shared/AdminButton'
import { DocumentTester } from '@/components/shared/DocumentTester'

import { useParseLoadInvoice } from './api'

type BaseProps = {
  loadId: string
}

export const LoadInvoiceTesterButton = ({ loadId }: BaseProps) => {
  const [isOpen, togglePanel] = useToggle()
  const [parseResult, setParseResult] = useState(null)
  const parseInvoice = useParseLoadInvoice(loadId)

  const handleSubmit = async (base64File: string) => {
    const result = await parseInvoice.mutateAsync({
      file: base64File,
    })
    setParseResult(result)
    return result
  }

  return (
    <>
      <AdminButton
        onClick={togglePanel}
        icon="cog"
        tooltip="Test load invoice"
        className="btn-sm"
      />
      <AdminSliderPanel isOpen={isOpen} onClose={togglePanel} width="60vw">
        <DocumentTester
          title="Load Invoice Tester"
          description="Test the invoice parsing for this load"
          buttonText="Parse invoice"
          onSubmit={handleSubmit}
          isLoading={parseInvoice.isPending}
          result={parseResult}
        />
      </AdminSliderPanel>
    </>
  )
}
